'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.beLeader = beLeader;
exports.createLeaderElection = createLeaderElection;

var _utils = require('../utils');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new _promise2.default(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return _promise2.default.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LeaderElection = function () {
  function LeaderElection(channel, options) {
    var _this = this;

    _classCallCheck(this, LeaderElection);

    this._channel = channel;
    this._options = options;

    this.isLeader = false;
    this.isDead = false;
    this.token = (0, _utils.randomToken)();

    this._isApplying = false;
    this._reApply = false;

    // things to clean up
    this._unloadFns = [];
    this._listeners = [];
    this._intervals = [];
    this._duplicateListeners = function () {};
    this._duplicateCalled = false;
    this._onBeforeDie = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    var unloadFn = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this.die());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function unloadFn() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (_utils.IS_BROWSER) {
      window.addEventListener('beforeUnload', unloadFn);
      window.addEventListener('unload', unloadFn);

      this._unloadFns.push(['beforeUnload', unloadFn]);
      this._unloadFns.push(['unload', unloadFn]);
    }
  }

  _createClass(LeaderElection, [{
    key: 'applyOnce',
    value: function applyOnce() {
      var _this2 = this;

      if (this.isLeader) return _promise2.default.resolve(false);
      if (this.isDead) return _promise2.default.resolve(false);

      // do nothing if already running
      if (this._isApplying) {
        this._reApply = true;
        return _promise2.default.resolve(false);
      }
      this._isApplying = true;

      var stopCriteria = false;
      var received = [];

      var handleMessage = function handleMessage(msg) {
        if (msg.context === 'leader' && msg.token !== _this2.token) {
          received.push(msg);

          if (msg.action === 'apply') {
            // Other is applying
            if (msg.token > _this2.token) {
              // Other has higher token, stop applying
              stopCriteria = true;
            }
          }

          if (msg.action === 'tell') {
            // Other is already leader
            stopCriteria = true;
          }
        }
      };
      this._channel.addEventListener('internal', handleMessage);

      return _sendMessage(this, 'apply') // send out that this one is applying
      .then(function () {
        return (0, _utils.sleep)(_this2._options.responseTime);
      }) // let others time to respond
      .then(function () {
        if (stopCriteria) return _promise2.default.reject(new Error());else return _sendMessage(_this2, 'apply');
      }).then(function () {
        return (0, _utils.sleep)(_this2._options.responseTime);
      }) // let others time to respond
      .then(function () {
        if (stopCriteria) return _promise2.default.reject(new Error());else return _sendMessage(_this2);
      }).then(function () {
        return beLeader(_this2);
      }) // no one disagreed -> this one is now leader
      .then(function () {
        return true;
      }).catch(function () {
        return false;
      }) // apply not successful
      .then(function (success) {
        _this2._channel.removeEventListener('internal', handleMessage);
        _this2._isApplying = false;
        if (!success && _this2._reApply) {
          _this2._reApply = false;
          return _this2.applyOnce();
        } else return success;
      });
    }
  }, {
    key: 'awaitLeadership',
    value: function awaitLeadership() {
      if (!this._awaitLeadershipPromise) {
        this._awaitLeadershipPromise = _awaitLeadershipOnce(this);
      }
      return this._awaitLeadershipPromise;
    }
  }, {
    key: 'die',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var _this3 = this;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.isDead) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                this.isDead = true;

                _context3.next = 5;
                return this.onBeforeDie();

              case 5:
                this._listeners.forEach(function (listener) {
                  return _this3._channel.removeEventListener('internal', listener);
                });
                this._intervals.forEach(function (interval) {
                  return clearInterval(interval);
                });
                this._unloadFns.forEach(function (uFn) {
                  if (_utils.IS_BROWSER) {
                    window.removeEventListener(uFn[0], uFn[1]);
                  }
                });
                return _context3.abrupt('return', _sendMessage(this, 'death'));

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function die() {
        return _ref3.apply(this, arguments);
      }

      return die;
    }()
  }, {
    key: 'onDuplicate',
    set: function set(fn) {
      this._duplicateListeners = fn;
    }

    /* istanbul ignore next */
    ,
    get: function get() {
      return this._duplicateListeners;
    }
  }, {
    key: 'onBeforeDie',
    set: function set(fn) {
      this._onBeforeDie = fn;
    }

    /* istanbul ignore next */
    ,
    get: function get() {
      return this._onBeforeDie;
    }
  }]);

  return LeaderElection;
}();

function _awaitLeadershipOnce(leaderElector) {
  if (leaderElector.isLeader) return _promise2.default.resolve();

  return new _promise2.default(function (resolve) {
    var resolved = false;

    function finish() {
      /* istanbul ignore next */
      if (resolved) {
        return;
      }
      resolved = true;
      clearInterval(interval);
      leaderElector._channel.removeEventListener('internal', whenDeathListener);
      resolve(true);
    }

    // try once now
    leaderElector.applyOnce().then(function () {
      if (leaderElector.isLeader) {
        finish();
      }
    });

    // try on fallbackInterval
    var interval = setInterval(function () {
      /* istanbul ignore next */
      leaderElector.applyOnce().then(function () {
        if (leaderElector.isLeader) {
          finish();
        }
      });
    }, leaderElector._options.fallbackInterval);
    leaderElector._intervals.push(interval);

    // try when other leader dies
    var whenDeathListener = function whenDeathListener(msg) {
      if (msg.context === 'leader' && msg.action === 'death') {
        leaderElector.applyOnce().then(function () {
          if (leaderElector.isLeader) finish();
        });
      }
    };
    leaderElector._channel.addEventListener('internal', whenDeathListener);
    leaderElector._listeners.push(whenDeathListener);
  });
}

/**
 * Sends and internal message over the broadcast-channel
 */
function _sendMessage(leaderElector, action) {
  var msgJson = {
    context: 'leader',
    action: action,
    token: leaderElector.token
  };
  return leaderElector._channel.postInternal(msgJson);
}

function beLeader(leaderElector) {
  leaderElector.isLeader = true;

  var isLeaderListener = function isLeaderListener(msg) {
    if (msg.context === 'leader' && msg.action === 'apply') {
      _sendMessage(leaderElector, 'tell');
    }

    if (msg.context === 'leader' && msg.action === 'tell' && !leaderElector._duplicateCalled) {
      /**
       * Another instance is also leader!
       * This can happen on rare events
       * like when the CPU is at 100% for long time
       * or the tabs are open very long and the browser throttles them.
       */
      leaderElector._duplicateCalled = true;
      leaderElector._duplicateListeners(); // message the lib user so the app can handle the problem
      _sendMessage(leaderElector, 'tell'); // ensure other leader also knows the problem
    }
  };
  leaderElector._channel.addEventListener('internal', isLeaderListener);
  leaderElector._listeners.push(isLeaderListener);
  return _sendMessage(leaderElector, 'tell');
}

function createLeaderElection(channel, options) {
  var _this4 = this;

  if (channel._leaderElector) {
    throw new Error('❌ MessageChannel already has a leader-elector');
  }

  var elector = new LeaderElection(channel, options);
  channel._beforeClose.push(_asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', elector.die());

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this4);
  })));

  channel._leaderElector = elector;
  return elector;
}